module.exports = __webpack_public_path__ + "img/active_package.00c74e72.png";